import type { FontLoadOptions } from "@solidtv/solid";

const basePath = import.meta.env.BASE_URL;

const fonts: FontLoadOptions[] = [
  {
    type: "msdf",
    fontFamily: "Roboto",
    aliases: ["Arial", "sans-serif"],
    atlasDataUrl: basePath + "fonts/Roboto-Regular.msdf.json",
    atlasUrl: basePath + "fonts/Roboto-Regular.msdf.png",
    metrics: {
      ascender: 1000,
      descender: 100,
      lineGap: 0,
      unitsPerEm: 1000
    }
  },
  {
    type: "msdf",
    fontFamily: "Roboto700",
    atlasDataUrl: basePath + "fonts/Roboto-Bold.msdf.json",
    atlasUrl: basePath + "fonts/Roboto-Bold.msdf.png",
    metrics: {
      ascender: 1000,
      descender: 100,
      lineGap: 0,
      unitsPerEm: 1000
    }
  },
  {
    type: "msdf",
    fontFamily: "Raleway",
    atlasDataUrl: basePath + "fonts/Raleway-ExtraBold.msdf.json",
    atlasUrl: basePath + "fonts/Raleway-ExtraBold.msdf.png"
  }
];
export default fonts;
